import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, withScopeId as _withScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-b1c60f92")

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  return (_openBlock(), _createBlock("button", {
    class: "dropdown-item",
    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClick()))
  }, _toDisplayString(_ctx.label), 1))
})